<template>
  <v-flex>
    <v-card-actions>
      <label style="font-size:17px;top:15px;color:#333333;">Image name : &nbsp;</label>
      <label style="font-size:17px;top:15px;color:#616A6B;">{{ selectedFile.logo_name }}</label>
      <v-spacer/>
      <v-btn flat color="red" @click="backToImageUploader()">Back</v-btn>
      <v-btn @click="cropImage" v-if="logoSrc != ''" color="primary" class="black--text">Crop</v-btn>
    </v-card-actions>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center my-2">
        <div
          :style="{width: (height*1.3) + 'px' ,  height: height ,  border: '1px solid gray' , display: 'inline-block'}"
        >
          <vue-cropper
            :aspectRatio="16/9"
            ref="cropper"
            :cropBoxResizable="true"
            :guides="true"
            :view-mode="2"
            drag-mode="none"
            :auto-crop-area="0.5"
            :min-container-width="height*1.3"
            :min-container-height="height"
            :background="true"
            :rotatable="true"
            :src="logoSrc"
            alt="Source Image"
            :img-style="{ width: (height*1.3) + 'px' ,  height: height}"
          ></vue-cropper>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import VueCropper from "vue-cropperjs";
export default {
  props: ["logoSrc", "selectedFile", "store_data"],
  components: {
    VueCropper
  },
  data() {
    return {
      height: 300
    };
  },
  watch: {},
  methods: {
    backToImageUploader() {
      this.selectedFile.logo_name = "";
      this.$emit("changeComponents", "imageUploader");
    },
    cropImage() {
      this.$emit(
        "getCroped",
        this.$refs.cropper.getCroppedCanvas().toDataURL("image/jpeg")
      );
      this.$emit("changeComponents", "imageUploader");
    }
  },
  created() {}
};
</script>
<style scoped>
</style>